export type GUID = string;
let pageGuid: GUID | undefined;

export const getPageGuid = () => pageGuid;
export const setPageGuid = (guid: GUID) => {
  pageGuid = guid;
};
